import React from 'react';
import RepuestoManager from '../repuesto/RepuestoManager';

// Unificado: un solo gestor de productos/repuestos con pricing completo
export default function GestorProductos() {
    return <RepuestoManager />;
}
